// extracted by mini-css-extract-plugin
module.exports = {"page-comp":"Tab_page-comp__1MGxR"};